import React from 'react';
import {View} from 'react-native';

import Card from '/component/base/Card';
import PeopleListItem from '/component/base/PeopleListItem';
import PercentageProgressListItem from '/component/base/PercentageProgressListItem';
import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';
import {withTranslation} from '/provider/TranslationProvider';

import {styles} from './CabBanner.style';

export interface CabBannerProps {
  tt: (key: string, params?: any) => string;
  cabBannerFqv: string;
  orderingEntities: number;
  daysLeftForCAB: number;
  showCABBanner: boolean;
}

export const CabBanner = ({
  tt = withTranslation.ttDefaultProp,
  cabBannerFqv = '',
  orderingEntities = 0,
  daysLeftForCAB = 0,
  showCABBanner,
}: CabBannerProps) => {
  return (
    showCABBanner && (
      <View accessible={true}>
        <Gutter>
          <Card
            hasBorder={false}
            style={{...styles.base, ...styles.backgroundColor}}
            shadow>
            <View style={{...styles.badge}}>
              <Text variant="caption">{tt('button', 'Expiring')}</Text>
            </View>
            <Text variant="heading" style={styles.text}>
              {tt('youHave', 'You have ')}
              {`${daysLeftForCAB} `}
              {daysLeftForCAB === 1 ? tt('day', 'day ') : tt('days', 'days ')}
              {tt(
                'leftToClaim',
                'left to claim your $100 Client Acquisition Bonus!!',
              )}
            </Text>
            <PeopleListItem
              canExpand={false}
              currentCount={orderingEntities > 5 ? 5 : orderingEntities}
              hasCheckbox
              isChecked={orderingEntities >= 5}
              label={<Text>{tt('clients', 'Clients')}</Text>}
              readonly
              style={{
                listItem: {
                  base: {...styles.backgroundColor, ...styles.peopleListItem},
                },
              }}
              targetCount={5}
            />
            <PercentageProgressListItem
              denominator={1000}
              hasCheckbox
              isChecked={cabBannerFqv >= 1000}
              label={<Text>{tt('fqv', '1000 FQV')}</Text>}
              numerator={cabBannerFqv > 1000 ? 1000 : cabBannerFqv}
              readonly
              style={{listItem: {base: {...styles.backgroundColor}}}}
            />
          </Card>
        </Gutter>
      </View>
    )
  );
};

export default withTranslation('dashboard.cabBanner')(CabBanner);
